import { Component, OnInit } from "@angular/core";
import { DataService } from "../../data.service";
import { Observable } from "rxjs";

@Component({
    selector: 'app-cargo-info',
    templateUrl: 'cargo-info.component.html',
    standalone: false
})
export class CargoInfoComponent implements OnInit {
    cargoInfo: string = "";

    constructor(private dataService: DataService) {
    }

    ngOnInit(): void {
        const subscr = this.dataService.cargoInfo().subscribe({
            next: (data) => {
                this.cargoInfo = data;
            },
            complete: () => {
                subscr.unsubscribe();
            },
            error: (err) => {
                console.log(err);
                subscr.unsubscribe();
            }
        });
    }

}